module.exports = __webpack_public_path__ + "img/木香.10f26d3e.jpg";